import styled from '@emotion/styled'
import { padding } from 'polished'
import * as React from 'react'
import Loader from './Loader'

const StyledLoader = styled(Loader)<{ isLoading: boolean }>(props => ({
  position: 'absolute',
  zIndex: 1,
  right: 0,
  top: 0,
  opacity: props.isLoading ? '1' : '0',
  transform: 'scale(0.6)',
  transition: 'all 200ms'
}))

const CanvaLoader: React.FC<{ designId: string; paddingTop?: string }> = ({ designId, paddingTop = '140%' }) => {
  const [isLoading, setIsLoading] = React.useState(true)

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 0,
        paddingTop,
        paddingBottom: '48px',
        boxShadow: '0 2px 8px 0 rgba(63, 69, 81, 0.16)',
        marginTop: '1.6em',
        marginBottom: '0.9em',
        overflow: 'hidden',
        willChange: 'transform'
      }}
    >
      <StyledLoader isLoading={isLoading} />

      <iframe
        onLoad={() => setIsLoading(false)}
        title="Commenorative book"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          border: 'none',
          padding: 0,
          margin: 0
        }}
        src={`https://www.canva.com/design/${designId}/view?embed`}
      />
    </div>
  )
}

export default CanvaLoader
